export default function checkPrintPermission(user, input) {
  const { role } = user
  if (role === 'Super Administrator') {
    return true
  } else if (role === 'District Admin') {
    if (input!==null && (input.district && input.district === user.schoolDistrict) || (input.schoolDistrict && input.schoolDistrict === user.schoolDistrict)) {
      return true
    } else return false
  } else if (role === 'School Admin') {
    if (input.school === user.school) {
      return true
    } else return false
  } else if (role === 'Teacher') {
    if (input.school === user.school) {
      return true
    } else return false
  } else if (role === 'Student') {
    if (input.userId === user.id) {
      return true
    } else return false
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/checkPrintPermission.js